<ng-container *ngIf="fieldTypeSpecs">
  <div *ngIf="viewState === viewStates.EDIT" class="mb-3 text-center">
    Select a level for each competency
  </div>

  <ng-container
    *ngFor="let competency of fieldTypeSpecs.competencies; index as ci">
    <div class="fw-600 fs-16 mb-2">{{ competency.title }}</div>
    <div class="levels-wrapper mb-3">
      <ng-container *ngFor="let gi of competency.gis; index as gi_lvl">
        <div
          class="level-item {{ question.id + '_comp_' + ci }}"
          id="{{ question.id + '_comp_' + ci + '_lvl_' + (gi_lvl + 1) }}"
          [class.interactive]="isInputInteractive"
          (click)="selectLevel(ci, gi_lvl + 1, $event)">
          <div class="level-header">
            {{ fieldTypeSpecs.levelNames[gi_lvl] | uppercase }}
          </div>
          <div class="level-content">
            {{ gi }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
